import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import * as utils from '@utils'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import Divider from '@material-ui/core/Divider'
import { Button, Grid } from '@material-ui/core'
import { addToast } from '../../../utils/toast'

const initialState = {
    title: '',
    dialogOpen: false,
    name: '',
    imageData: {
        CHS: null,
        ENU: null,
        VIE: null,
        THA: null,
        ESP: null,
        PTE: null,
    },
    pf_id: '',
    pfSubPfIDList: [],
    pfSubTree: [],
    imgType: 'bannerImg',
    typeRole: {
        bannerImg: {
            width: 651,
            height: 644,
            size: 150,
            format: ['jpeg', 'png'],
        },
        iconImg: {
            width: 128,
            height: 128,
            size: 20,
            format: ['png'],
        },
    },
}

class UploadActivityImgDialog extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key) => {
            return utils.t(key, 'UploadActivityImgDialog')
        }
        this.state = initialState
    }

    componentDidMount() {
        this.props.onRef(this)
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    OpenDialog(inputs) {
        const states = {
            dialogOpen: true,
            title: inputs.title,
            imageData: this.state.imageData
        }
        if (inputs?.imageData) {
            states.imageData = {
                ...initialState.imageData, ...inputs.imageData
            }
        }

        this.setState(states)
    }

    closeDialog() {
        this.setState({ dialogOpen: false })
    }

    verifyData() {
        const verifyRule = {  // 僅中文跟英文為必上傳
            noImageUploaded: this.state.imageData.CHS === null || this.state.imageData.ENU === null,
        }

        const errorList = []
        Object.entries(verifyRule).forEach(([key, item]) => {
            if (item) {
                if (key === 'noImageUploaded') {
                    ['CHS', 'ENU'].forEach((imgkey) => {
                        if (this.state.imageData[imgkey] === null) addToast(utils.t(key, 'ActivityImageDialog', { currency: utils.t('Language.' + imgkey) }), 'error')
                    })
                } else {
                    addToast(utils.t(key, 'ActivityImageDialog'), 'error')
                }
                errorList.push(key)
            }
        })

        return errorList.length === 0 ? true : false
    }

    addActivityImage() {
        if (this.verifyData()) {
            const formData = new FormData()
            Object.entries(this.state.imageData).forEach(([key, item]) => {
                formData.append(key, item)
            })
            if (this.props.confirmCallback) {
                this.props.confirmCallback()
            }
            this.closeDialog()
        }
    }

    async verifyType(file) {
        return new Promise((reslove) => {
            const typeRole = this.state.typeRole[this.state.imgType]
            const image = new Image()
            image.src = file.src

            image.onload = () => {
                file.width = image.width
                file.height = image.height
                if (
                    !typeRole.format.includes(file.type.replace('image/', '')) ||
                    file.size / 1024 > typeRole.size ||
                    file.width > typeRole.width ||
                    file.height > typeRole.height
                ) {
                    return reslove(false)
                }
                return reslove(true)
            }
            image.onerror = () => {
                return reslove(false)
            }
        })
    }

    uploadImage(key) {
        const fileInput = document.getElementById(`fileInput-${key}`)
        const file = fileInput.files[0]

        let imgReader
        if (file) {
            imgReader = new FileReader()
            imgReader.readAsDataURL(file)
            imgReader.onload = async (event) => {
                file.src = event.target.result
                const verifyResult = await this.verifyType(file)
                if (!verifyResult) {
                    addToast(utils.t('typeError', 'ActivityImageDialog'), 'error')
                    return
                }

                this.setState({
                    imageData: {
                        ...this.state.imageData,
                        [key]: file,
                    },
                })
            }
        }
    }

    render() {
        return (
            <Dialog fullWidth maxWidth="sm" open={this.state.dialogOpen} onClose={() => this.setState({ dialogOpen: false })}>
                <DialogTitle>{this.state.title}</DialogTitle>
                <DialogContent className={this.props.classes.dialogContent}>
                    <Grid container spacing={2}>
                        <Grid container item xs={12} spacing={2}>
                            <Grid item xs={12}>
                                {utils.t('previewUploadedImg', 'ActivityImageDialog')}
                            </Grid>
                            {Object.keys(this.state.imageData).map((key) => {
                                const data = this.state.imageData[key]
                                return (
                                    <Grid item xs={6} key={key}>
                                        <div className={this.props.classes.language}>{utils.t('Language.' + key)}</div>
                                        <input
                                            accept="image/*"
                                            style={{ display: 'none' }}
                                            id={`fileInput-${key}`}
                                            type="file"
                                            onChange={() => {
                                                this.uploadImage(key)
                                            }}
                                        />
                                        <label className={this.props.classes.imageContainer} htmlFor={`fileInput-${key}`}>
                                            {data ? (
                                                <img
                                                    src={data instanceof File ? data.src : data}
                                                    alt={`img-${key}`}
                                                    id={`img-${key}`}
                                                    className={this.props.classes.imageContainer}
                                                />
                                            ) : (
                                                <div>{utils.t('previewUploadedImg', 'EventDialog')}</div>
                                            )}
                                        </label>
                                    </Grid>
                                )
                            })}
                        </Grid>
                    </Grid>
                </DialogContent>
                <Divider />
                <DialogActions>
                    <div className={this.props.classes.dialogActions}>
                        <div className={this.props.classes.hintText}>
                            {utils.t('hintText', 'EventDialog', {
                                width: this.state.typeRole[this.state.imgType].width,
                                height: this.state.typeRole[this.state.imgType].height,
                                size: this.state.typeRole[this.state.imgType].size,
                                format: this.state.typeRole[this.state.imgType].format.join().replace(',',` ${this.t('or')} `),
                            })}
                        </div>
                        <div>
                            <Button variant="contained" onClick={() => this.addActivityImage()} color="primary">
                                {this.t('confirm')}
                            </Button>
                            <Button className={this.props.classes.cancelBtn} variant="contained" onClick={() => this.closeDialog()} color="secondary">
                                {this.t('cancel')}
                            </Button>
                        </div>
                    </div>
                </DialogActions>
            </Dialog>
        )
    }
}

const styles = (_theme) => {
    return {
        formControl: {
            marginTop: '30px',
            width: '150px',
        },
        dialogContent: {
            height: '640px',
        },
        imageContainer: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '145px',
            width: '100%',
            borderWidth: '0.5px',
            borderColor: 'black',
            borderStyle: 'solid',
            borderRadius: '5px',
            cursor: 'pointer',
        },
        language: {
            paddingBottom: '2px',
        },
        shrink: {
            transform: 'translate(0, 1.5px) scale(0.75)',
            transformOrigin: 'top left',
            marginBottom: '0',
            paddingLeft: '24px',
        },
        gridAlignment: {
            margin: '-8px',
            marginTop: '20px',
        },
        treeSelect: {
            width: '200px',
            paddingLeft: '20px',
            marginTop: '30px',
        },
        specifyRadio: {
            marginTop: '20px',
            marginBottom: '-20px',
        },
        cancelBtn: {
            marginLeft: '8px',
        },
        hintText: {
            color: 'red',
        },
        dialogActions: {
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            alignItems: 'center',
        },
    }
}

UploadActivityImgDialog.propTypes = {
    classes: PropTypes.object.isRequired,
    onRef: PropTypes.func,
    confirmCallback: PropTypes.func,
}

export default hoc(styles)(UploadActivityImgDialog)
